// Field configurations for the generic admin Resource Manager.
import {
  SOCIAL_WORK_CATEGORIES, GALLERY_CATEGORIES,
} from "@/data/constants";

const swCats = SOCIAL_WORK_CATEGORIES.filter((c) => c !== "All");
const galCats = GALLERY_CATEGORIES.filter((c) => c !== "All");

export const RESOURCE_CONFIGS = {
  milestones: {
    resource: "milestones",
    title: "Milestones",
    singular: "Milestone",
    columns: ["year", "title", "category", "order"],
    fields: [
      { key: "year", label: "Year", type: "text", required: true },
      { key: "title", label: "Title", type: "text", required: true },
      { key: "title_kn", label: "Title (Kannada)", type: "text" },
      { key: "category", label: "Category", type: "text" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "description_kn", label: "Description (Kannada)", type: "textarea" },
      { key: "image", label: "Image", type: "image" },
      { key: "order", label: "Display Order", type: "number" },
      { key: "isActive", label: "Active", type: "boolean", default: true },
    ],
  },
  "social-work": {
    resource: "social-work",
    title: "Social Work Posts",
    singular: "Post",
    columns: ["title", "category", "date", "status"],
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "slug", label: "Slug (url)", type: "text", required: true, hint: "e.g. free-health-camp" },
      { key: "category", label: "Category", type: "select", options: swCats, required: true },
      { key: "date", label: "Date", type: "date" },
      { key: "location", label: "Location", type: "text" },
      { key: "locality", label: "Locality / Area", type: "text" },
      { key: "relatedToHoodi", label: "Related to Hoodi Ward 29?", type: "boolean", default: true },
      { key: "shortDescription", label: "Short Description", type: "textarea" },
      { key: "fullDescription", label: "Full Description", type: "textarea", rows: 6 },
      { key: "featuredImage", label: "Featured Image", type: "image" },
      { key: "galleryImages", label: "Gallery Images", type: "imageList" },
      { key: "beneficiaryCount", label: "Beneficiaries", type: "text" },
      { key: "partners", label: "Partners / Organisers", type: "text" },
      { key: "seoTitle", label: "SEO Title", type: "text" },
      { key: "seoDescription", label: "SEO Description", type: "textarea" },
      { key: "status", label: "Status", type: "select", options: ["published", "draft"], default: "published" },
    ],
  },
  awards: {
    resource: "awards",
    title: "Awards",
    singular: "Award",
    columns: ["title", "year", "organization", "order"],
    fields: [
      { key: "title", label: "Award Name", type: "text", required: true },
      { key: "year", label: "Year", type: "text", required: true },
      { key: "organization", label: "Awarding Organization", type: "text" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "image", label: "Certificate / Photo", type: "image" },
      { key: "order", label: "Display Order", type: "number" },
    ],
  },
  "leadership-roles": {
    resource: "leadership-roles",
    title: "Leadership Roles",
    singular: "Role",
    columns: ["position", "organization", "duration", "order"],
    fields: [
      { key: "position", label: "Position", type: "text", required: true },
      { key: "organization", label: "Organization", type: "text", required: true },
      { key: "duration", label: "Duration", type: "text" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "achievements", label: "Achievements", type: "textarea" },
      { key: "image", label: "Image / Logo", type: "image" },
      { key: "order", label: "Display Order", type: "number" },
    ],
  },
  gallery: {
    resource: "gallery",
    title: "Gallery",
    singular: "Image",
    columns: ["title", "category", "date", "order"],
    fields: [
      { key: "image", label: "Image", type: "image", required: true },
      { key: "title", label: "Title", type: "text", required: true },
      { key: "category", label: "Category", type: "select", options: galCats },
      { key: "altText", label: "Alt Text", type: "text" },
      { key: "date", label: "Date", type: "date" },
      { key: "order", label: "Display Order", type: "number" },
    ],
  },
  media: {
    resource: "media",
    title: "Media / Press",
    singular: "Media Item",
    columns: ["title", "mediaName", "type", "date"],
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "mediaName", label: "Media Name", type: "text" },
      { key: "type", label: "Type", type: "select", options: ["article", "video", "press release"] },
      { key: "date", label: "Date", type: "date" },
      { key: "externalLink", label: "External Link", type: "text" },
      { key: "image", label: "Image", type: "image" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "order", label: "Display Order", type: "number" },
    ],
  },
  facts: {
    resource: "facts",
    title: "Facts (FAQ)",
    singular: "Fact",
    columns: ["question", "order"],
    fields: [
      { key: "question", label: "Question", type: "text", required: true },
      { key: "answer", label: "Answer", type: "textarea", rows: 4 },
      { key: "order", label: "Display Order", type: "number" },
    ],
  },
  "page-seo": {
    resource: "page-seo",
    title: "SEO Settings",
    singular: "Page SEO",
    columns: ["pageSlug", "metaTitle"],
    fields: [
      { key: "pageSlug", label: "Page Slug", type: "text", required: true, hint: "e.g. home, about" },
      { key: "metaTitle", label: "Meta Title", type: "text" },
      { key: "metaDescription", label: "Meta Description", type: "textarea" },
      { key: "keywords", label: "Keywords", type: "text" },
      { key: "ogImage", label: "OG Image", type: "image" },
      { key: "canonicalUrl", label: "Canonical URL", type: "text" },
    ],
  },
};
